import React, { Component } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

// users
// import user1 from "../../../assets/images/users/avatar-1.jpg"

import { connect } from "react-redux"
import ReactDrawer from "react-drawer";
import "react-drawer/lib/react-drawer.css";
import UserProfile from "../../pages/Authentication/UserProfile";

class ProfileMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
      fname: this.props.profileData.fname,
      sname: this.props.profileData.sname,
      profilePic: this.props.profileData.profilePic,
      open: false,
      position: "right",
    }
    this.toggleRightDrawer = this.toggleRightDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.onDrawerClose = this.onDrawerClose.bind(this);
    this.setPosition = this.setPosition.bind(this);
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }

  // componentDidMount() {
  //   const userData = getUserName();
  //   if (userData) {
  //     this.setState({ fname: userData.result.fname, sname: userData.result.sname, profilePic: userData.result.profilePic })
  //   }
  // }

  componentDidUpdate(prevProps) {
    if (prevProps.success !== this.props.success) {
      // const userData = getUserName();
      // if (userData) {
        this.setState({ fname: this.props.profileData.fname, sname: this.props.profileData.sname, profilePic: this.props.profileData.profilePic })
      // }
    }
  }
  setPosition(e) {
    this.setState({ position: e.target.value });
  }
  toggleRightDrawer() {
    this.setState({ position: "right" });
    this.setState({ open: !this.state.open });
  }
  closeDrawer() {
    this.setState({ open: false });
  }
  onDrawerClose() {
    this.setState({ open: false });
  }
  render() {
    const { profileData } = this.props;
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item"
            id="page-header-user-dropdown"
            tag="button"
          >
            {this.state.profilePic === "" ? (
              <div className="mt-2 rounded-circle header-profile-user d-xl-inline-block">
                <span className=" avatar-title rounded-circle">
                  {this.state.fname.charAt(0)}
                </span>
              </div>
            ) : (
              <img
                className="rounded-circle header-profile-user"
                src={this.state.profilePic}
                alt="Header Avatar"
              />
            )}
            <span className="d-none d-xl-inline-block ms-1">
              {this.state.fname}
            </span>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem tag="a" href="#" onClick={this.toggleRightDrawer} >
              <i className="bx bx-user font-size-16 align-middle ms-1" />
              {this.props.t("Profile")}
            </DropdownItem>
            <DropdownItem tag="a" href="auth-lock-screen">
              <i className="bx bx-lock-open font-size-16 align-middle me-1" />
              {this.props.t("Lock screen")}
            </DropdownItem>
            <div className="dropdown-divider" />
            <Link to="/logout" className="dropdown-item">
              <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
              <span>{this.props.t("Logout")}</span>
            </Link>
          </DropdownMenu>
        </Dropdown>
        <ReactDrawer
          open={this.state.open}
          className="drawer-open"
          position={this.state.position}
          onClose={this.onDrawerClose}
        >
          <UserProfile profileData={profileData} />
        </ReactDrawer>
      </React.Fragment>
    )
  }
}

ProfileMenu.propTypes = {
  t: PropTypes.any
}

const mapStateToProps = state => {
  const { success } = state.Profile
  return { success }
}


export default withRouter(
  connect(mapStateToProps, {})(withTranslation()(ProfileMenu))
)

// export default withRouter((ProfileMenu))
